// Module
var code = "<div><ul><li ng-repeat=\"m in parameter | limitTo: 10\"><a ng-href=\"{{m.authorityUrl}}\">{{m.name}}</a><span>({{m.period.from}}-{{m.period.to || ''}})</span></li><li ng-show=\"parameter.length &gt; 10\">...</li></ul></div>";
// Exports
var _module_exports =code;;
var path = '/ng-templates/src/use-cases/provenio/historical-places-window.tpl.pug';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;